import { render, staticRenderFns } from "./SubscribeToPremiumTooltipWrapper.vue?vue&type=template&id=14685619&scoped=true"
import script from "./SubscribeToPremiumTooltipWrapper.vue?vue&type=script&lang=js"
export * from "./SubscribeToPremiumTooltipWrapper.vue?vue&type=script&lang=js"
import style0 from "./SubscribeToPremiumTooltipWrapper.vue?vue&type=style&index=0&id=14685619&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14685619",
  null
  
)

export default component.exports